import { jsx as _jsx } from "react/jsx-runtime";
import { LENDER_ROUTES } from 'legacy/_constants/routes';
import LegacyFundingRequests from 'legacy/_views/LenderViews/FundingRequestOverview';
import { Page } from 'xen/components';
const FundingRequests = () => {
    // Should eventually be replaced by new Xen 1.0 page
    return (_jsx(Page, { pt: "0", children: _jsx(LegacyFundingRequests, { location: { pathname: LENDER_ROUTES.funding_requests_all } }) }));
};
export default FundingRequests;
